import "./Footer.css";
import { ThemeToggle } from "../ThemeToggle/ThemeToggle";

export default function Footer({ handleChange, isDark }) {
    return (
        <footer className="footer">
            <ThemeToggle isDark={isDark} handleChange={handleChange} />
            <p style={{ fontSize: "0.85em", textAlign: "center" }}>
                Created by{" "}
                <a href="https://graceis.online" target="_blank" rel="noreferrer">
                    Grace Manning
                </a>
                . Thanks for stopping by!
            </p>
        </footer>
    );
}
